import { render, staticRenderFns } from "./Weblogs.vue?vue&type=template&id=c04dcba8&scoped=true&"
import script from "./Weblogs.vue?vue&type=script&lang=js&"
export * from "./Weblogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04dcba8",
  null
  
)

export default component.exports